import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../config/auth-context';
import AccessDenied from '../pages/access-denied/access-denied'

interface ProtectedRouteProps {
  roles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles }) => {
  const { isAuthenticated, userRoles } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const hasRequiredRole = roles.some(role => userRoles.includes(role));

  if (!hasRequiredRole) {
    return <AccessDenied />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
